export default function DropDownBtn({
    data,
    caption,
    onSelect,
    id = "btnDropdown",
    btnClasses = "main--button btn-sm",
    btnStyles = {},
}) {
    return (
        <div className="dropdown">
            <button
                className={`btn dropdown-toggle ${btnClasses}`}
                type="button"
                id={id}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={btnStyles}
            >
                {caption}
            </button>
            <ul className="dropdown-menu" aria-labelledby={id}>
                {data.map((item) => (
                    <li key={item.id}>
                        <button className="dropdown-item" type="button" onClick={() => onSelect(item)}>
                            {item.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
